import styled from 'styled-components';

import { IInput } from './Input';

export const Wrapper = styled.div<IInput.IProps>`
   {
    position: relative;
    display: flex;
    padding-top: 16.5px;
    margin: ${({ marginWrapper }) => marginWrapper && marginWrapper};
  }
`;

export const InputText = styled.input<IInput.IProps>`
   {
    background-color: ${({ theme }) => theme.colors.gray800};
    border: ${({ theme, hasError }) => (hasError ? theme.colors.red500 : theme.colors.gray200)} 1px
      solid;
    border-radius: ${({ theme }) => theme.spacing.xs};
    padding: 0 32px 0 12px;
    font-style: normal;
    font-weight: 400;
    color: ${({ theme }) => theme.colors.gray0};
    font-size: ${({ theme }) => theme.typeSize.md};
    line-height: ${({ theme }) => theme.typeSize.xs};
    height: 40px;
    flex: 1;

    ::placeholder {
      color: ${({ theme }) => theme.colors.gray0};
      opacity: 0.3;
    }

    &:hover {
      box-shadow: 0 4px 4px rgba(6, 199, 141, 0.1);
      border-color: ${({ theme, hasError }) =>
        hasError ? theme.colors.red500 : theme.colors.gray400};

      ::placeholder {
        color: ${({ theme }) => theme.colors.gray0};
      }
    }

    &:focus {
      box-shadow: 0 2px 7px rgba(0, 0, 0, 0.08);
      border: ${({ theme, hasError }) => (hasError ? theme.colors.red500 : theme.colors.gray500)}
        1px solid;

      :hover {
        box-shadow: 0 4px 4px rgba(6, 199, 141, 0.15);
      }
    }
  }
`;

export const Label = styled.label<IInput.IProps>`
  font-style: normal;
  font-weight: 400;
  color: ${({ theme, hasError }) => (hasError ? theme.colors.red500 : theme.colors.gray0)};
  font-size: ${({ theme }) => theme.typeSize.xs};
  line-height: ${({ theme }) => theme.typeSize.xs};
  margin: 0 0 2.5px 0;
  position: absolute;
  top: 0;
  transition: 0.2s ease all;

  ${InputText}:hover ~ & {
    color: ${({ theme, hasError }) => (hasError ? theme.colors.red500 : theme.colors.green700)};
  }

  ${InputText}:focus ~ & {
    color: ${({ theme, hasError }) => (hasError ? theme.colors.green900 : theme.colors.green500)};
  }

  ${InputText}:focus:hover ~ & {
    color: ${({ theme, hasError }) => (hasError ? theme.colors.green900 : theme.colors.green600)};
  }
`;

export const TickIcon = styled.span`
  position: absolute;
  bottom: 14px;
  right: 16px;
  font-size: 11px;

  :before {
    color: ${({ theme }) => theme.colors.green500};
  }
`;

export const ErrorIcon = styled.span`
  position: absolute;
  bottom: 12px;
  right: 12px;
  font-size: 18px;

  :before {
    color: ${({ theme }) => theme.colors.red500};
  }
`;

export const Tooltip = styled.div`
  background: ${({ theme }) => theme.colors.red500};
  border-radius: 6px;
  -moz-border-radius: 6px;
  -webkit-border-radius: 6px;
  position: absolute;
  bottom: -31px;
  right: 6px;
  padding: 8px 4px 6px 4px;
  color: ${({ theme }) => theme.colors.gray0};
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 10px;
  opacity: 1;
  pointer-events: none;

  z-index: 1;
  ${ErrorIcon}:hover ~ & {
    opacity: 1;
    transform: translate3d(0, 10px, 0);
    transition: all 0.15s ease-in-out;
  }

  :after {
    content: '';
    border: 7px solid transparent;
    position: absolute;
    top: -12px;
    border-bottom-color: ${({ theme }) => theme.colors.red500};
    right: 7px;
  }
`;

export const CustomIcon = styled.div`
  position: absolute;
  bottom: 8px;
  right: 12px;
`;
